import type { AxiosRequestConfig } from 'axios';

export abstract class Authentication {
    /**
     * Apply authentication settings to header and query params.
     */
    public abstract applyToRequest(requestOptions: AxiosRequestConfig): Promise<void>;
}
